"use strict";

exports.__esModule = true;
exports.EditableGridElementBackground = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../Theme");
var _gridUtils = require("./gridUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var BackgroundSVG = _styledComponents["default"].svg.withConfig({
  displayName: "EditableGridElementBackground__BackgroundSVG",
  componentId: "sc-jr3zt4-0"
})(["background:", ";"], (0, _Theme.val)("ScreenBackground"));

/**
 * Displays grid lines and highlighted cells in an editable grid.
 */
var EditableGridElementBackground = exports.EditableGridElementBackground = /*#__PURE__*/function (_Component) {
  function EditableGridElementBackground() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(EditableGridElementBackground, _Component);
  var _proto = EditableGridElementBackground.prototype;
  _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
    return this.props.rowCount !== props.rowCount || this.props.columnCount !== props.columnCount || this.props.width !== props.width || this.props.height !== props.height || this.props.padding !== props.padding || !(0, _reactFastCompare["default"])(this.props.highlightedCells, props.highlightedCells);
  };
  _proto.render = function render() {
    var _this$props = this.props,
      padding = _this$props.padding,
      width = _this$props.width,
      height = _this$props.height,
      rowCount = _this$props.rowCount,
      columnCount = _this$props.columnCount;
    var lines = [];
    var rowHeight = (0, _gridUtils.getGridRowHeight)(this.props);
    var columnWidth = (0, _gridUtils.getGridColumnWidth)(this.props);
    for (var rowIndex = 0; rowIndex < rowCount - 1; rowIndex++) {
      lines.push(/*#__PURE__*/_react["default"].createElement("rect", {
        key: "row:" + rowIndex,
        fill: "rgba(0, 0, 0, 0.03)",
        x: padding,
        y: padding + (rowIndex + 1) * rowHeight,
        width: width - padding * 2,
        height: 1
      }));
    }
    for (var columnIndex = 0; columnIndex < columnCount - 1; columnIndex++) {
      lines.push(/*#__PURE__*/_react["default"].createElement("rect", {
        key: "column:" + columnIndex,
        fill: "rgba(0, 0, 0, 0.03)",
        x: padding + (columnIndex + 1) * columnWidth,
        y: padding,
        width: 1,
        height: height - padding * 2
      }));
    }
    var highlighted;
    var highlightedCells = this.props.highlightedCells;
    if (highlightedCells) {
      var position = (0, _gridUtils.getGridCellDimensions)(this.props, highlightedCells);
      highlighted = /*#__PURE__*/_react["default"].createElement("rect", _extends({
        key: "hover",
        fill: "rgba(175, 226, 241, 0.3)"
      }, position));
    }
    return /*#__PURE__*/_react["default"].createElement(BackgroundSVG, {
      width: width,
      height: height
    }, lines, highlighted);
  };
  return EditableGridElementBackground;
}(_react.Component);